webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });


var config = {
  apiKey: "AIzaSyCLE9AHpK5-OFDGfLZ8X0SxLh9XwR0nRxQ",
  authDomain: "namefinder-936ee.firebaseapp.com",
  databaseURL: "https://namefinder-936ee.firebaseio.com",
  storageBucket: "namefinder-936ee.appspot.com",
  messagingSenderId: "923738600597"
};

var app = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
var fireDB = void 0;

var db = function db() {
  if (!fireDB) {
    fireDB = app.database();
  }
  return fireDB;
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* unused harmony export empty */
/* unused harmony export userName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ratingAverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ratingOn100Scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTimeStamp; });

var Cookies = __webpack_require__(60);

Cookies.defaults = {
  path: '/'
};

var upercase = function upercase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var empty = function empty(string) {
  return string.lenght === 0 ? '' : string;
};
var userName = function userName(name) {
  return empty(name).toLowerCase().trim();
};

var User = function User() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$storage = _ref.storage,
      storage = _ref$storage === undefined ? Cookies : _ref$storage;

  return {
    set: function set(name) {
      storage.set('naming_username', userName(name), { expires: Infinity });
    },
    get: function get() {
      return userName(storage.get('naming_username'));
    },
    getFormated: function getFormated() {
      return upercase(userName(storage.get('naming_username')));
    },
    loggedIn: function loggedIn() {
      if (storage.get('naming_username')) {
        return true;
      }
      return false;
    }
  };
};

var add = function add(a, b) {
  return a + b;
};

var sumOfArray = function sumOfArray(array) {
  return array.reduce(add, 0);
};

var ratingAverage = function ratingAverage(rating) {
  if (!rating) {
    return 0;
  }
  return sumOfArray(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(rating)) / __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(rating).length;
};

var ratingOn100Scale = function ratingOn100Scale(rating) {
  var scale = 100;
  var maxCurrent = 5;
  return rating * scale / maxCurrent;
};

var formatTimeStamp = function formatTimeStamp(dateTime) {
  if (!dateTime) {
    return '';
  }
  var now = new Date(dateTime);

  var date = [now.getDate(), now.getMonth() + 1, now.getFullYear()];

  var time = [now.getHours(), now.getMinutes()];

  for (var i = 1; i < 3; i++) {
    if (time[i] < 10) {
      time[i] = "0" + time[i];
    }
  }

  return date.join(".") + " - " + time.join(":");
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      namesDb = _ref.namesDb;

  var addRating = function addRating(nameKey, user, rating) {
    return namesDb.child(nameKey).child('rating').child(user).set(rating);
  };

  var removeRating = function removeRating(nameKey, user) {
    return namesDb.child(nameKey).child('rating').child(user).remove();
  };
  var addComment = function addComment(nameKey, user, comment) {
    var obj = {
      comment: comment,
      user: user,
      dateTime: __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database.ServerValue.TIMESTAMP
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */])().ref('comment').child(nameKey).push(obj).then(function () {
      return namesDb.child(nameKey).child('totalComment').transaction(function (currentCount) {
        return currentCount + 1;
      });
    });
  };
  var addName = function addName(recommendation, user) {
    var obj = {
      value: recommendation,
      recommended: user,
      rating: {}
    };
    var recommendationNormalized = recommendation.toLowerCase();
    return namesDb.child(recommendationNormalized).once('value').then(function (snapshot) {
      if (snapshot.exists()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Name exists');
      }
      return namesDb.child(recommendationNormalized).set(obj);
    });
  };

  var removeName = function removeName(nameKey, user) {
    namesDb.child(nameKey).once('value').then(function (snapshot) {
      var name = snapshot.val();
      if (name.recommended === user) {
        return namesDb.child(nameKey).remove();
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('no ACL');
    }).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Error');
    });
  };

  return {
    addRating: addRating,
    removeRating: removeRating,
    addName: addName,
    removeName: removeName,
    addComment: addComment
  };
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NameCard__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NameCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NameCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ListUserRecommendations__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ListUserRecommendations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ListUserRecommendations__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/names/visibility/:visibility',
    name: 'Names',
    component: __WEBPACK_IMPORTED_MODULE_3__components_NameCard___default.a,
    props: true
  }, {
    path: '/mynames/',
    name: 'UserNames',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ListUserRecommendations___default.a
  }]
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app'
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StarRating__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StarRating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StarRating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chat_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Chat_vue__);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Card',
  props: ['name', 'addRating', 'removeRating', 'rating', 'addComment'],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0__StarRating___default.a,
    Chat: __WEBPACK_IMPORTED_MODULE_1__Chat_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: {
    myRating: function myRating() {
      if (this.name.rating && this.name.rating.marcus) {
        return this.name.rating.marcus;
      } else {
        return -1;
      }
    }
  },
  methods: {
    starChange: function starChange(selected, current) {
      if (selected == current) {
        this.removeRating(this.name['.key']);
      } else {
        this.addRating(this.name['.key'], selected);
      }
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatMessage_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ChatMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_names__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(7);







var sorting = function sorting(commentsArray) {
  return commentsArray.reverse();
};

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ChatMessage: __WEBPACK_IMPORTED_MODULE_0__ChatMessage_vue___default.a
  },
  props: ['addComment', 'nameRef'],
  data: function data() {
    return {
      commentMsg: '',
      showComments: false,
      comments: []
    };
  },

  computed: {
    sortedComments: function sortedComments() {
      return sorting(this.comments);
    }
  },
  methods: {
    comment: function comment() {
      this.addComment(this.nameRef['.key'], this.commentMsg);
      this.commentMsg = '';
    },
    toggleComments: function toggleComments() {
      return this.showComments = !this.showComments;
    },
    viewComments: function viewComments() {
      this.$bindAsArray('comments', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* db */])().ref('comment/' + this.nameRef['.key']).orderByValue().limitToLast(25));
      this.toggleComments();
    }
  }

};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(11);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ChatMessage',
  props: ['userName', 'datum', 'message'],
  computed: {
    dateTimeValue: function dateTimeValue() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_helper__["d" /* formatTimeStamp */])(this.datum);
    }
  }
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_names__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(11);



var names = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */])().ref('names');

var namesModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__models_names__["a" /* default */])({ namesDb: names });



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  data: function data() {
    return {
      userName: '',
      user: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])(),
      recommendation: '',
      modUser: false,
      recommendClass: '',
      formHintRecommendation: ''
    };
  },

  computed: {
    userNameAvailable: function userNameAvailable() {
      return this.user.loggedIn();
    },
    greeting: function greeting() {
      if (this.user.loggedIn()) {
        return this.user.getFormated();
      } else {
        return 'Bitte Benutzername eingeben';
      }
    }
  },
  methods: {
    setUserName: function setUserName() {
      if (this.userName) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().set(this.userName);
        this.user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])();
        this.toggleUserEdit();
      } else {
        this.greeting = 'Wir brauchen einen Benutzernamen';
      }
    },
    move: function move(object) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(object);
    },
    toggleUserEdit: function toggleUserEdit() {
      this.modUser = !this.modUser;
    },
    addName: function addName() {
      var _this = this;

      namesModel.addName(this.recommendation, this.user.get()).then(function () {
        _this.formHintRecommendation = _this.recommendation + ' hinzugef\xFCgt';
        _this.recommendation = '';
        _this.recommendClass = 'has-success';
        setTimeout(function () {
          _this.formHintRecommendation = '';
          _this.recommendClass = '';
        }, 2000);
      }).catch(function () {
        _this.recommendClass = 'has-danger';
        _this.formHintRecommendation = 'Der Name ' + _this.recommendation + ' existiert schon.';
        setTimeout(function () {
          _this.formHintRecommendation = '';
          _this.recommendClass = '';
        }, 2000);
      });
    }

  }
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_names__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_helper__ = __webpack_require__(11);




var names = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */])().ref('names');

var namesModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_names__["a" /* default */])({ namesDb: names });




var filterUserRecommendations = function filterUserRecommendations(user) {
  return function (name) {
    return name.recommended === user;
  };
};

var sort = {
  asc: function asc(names) {
    return names.sort(function (a, b) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* ratingAverage */])(a.rating) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* ratingAverage */])(b.rating);
    });
  }
};

var addStat = function addStat(name) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, name, {
    stat: {
      average: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* ratingAverage */])(rating).toFixed(2),
      count: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["values"])(rating).length,
      endResult: ratingCount(rating) * average(rating)
    }
  });
};

var namesWithStat = function namesWithStat(namesRef) {
  if (typeof namesRef === 'undefined') {
    return [];
  }
  return namesRef.map(addStat);
};

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ListUserRecommendations',
  data: {
    sortOrder: 'asc',
    names: []
  },
  computed: {},
  methods: {
    deleteRecommendation: function deleteRecommendation(nameKey) {
      return namesModel.removeName(nameKey, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["b" /* User */])().get());
    },
    average: function average(rating) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* ratingAverage */])(rating).toFixed(2);
    },
    ratingCount: function ratingCount(rating) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["values"])(rating).length;
    },
    endRating: function endRating(rating) {
      return this.ratingCount(rating) * this.average(rating);
    },
    barRating: function barRating(rating) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["c" /* ratingOn100Scale */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["a" /* ratingAverage */])(rating));
    }
  },
  firebase: {
    names: names
  }
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_names__ = __webpack_require__(12);



var names = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */])().ref('names');






var namesModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__models_names__["a" /* default */])({ namesDb: names });

var notRatedByMe = function notRatedByMe(name) {
  if (name.rating && name.rating[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get()]) {
    return false;
  } else {
    return true;
  }
};

var not = function not(bool) {
  return !bool;
};

var filters = {
  all: function all(names) {
    return names;
  },
  unrated: function unrated(names) {
    return names.filter(notRatedByMe);
  },
  byme: function byme(names) {
    return names.filter(function (name) {
      return !notRatedByMe(name);
    });
  },
  favorite: function favorite(names) {
    return names.filter(function (name) {
      return name.hasOwnProperty('favorite');
    });
  }
};

var sort = {};

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1__Card___default.a
  },
  props: ['visibility'],
  data: function data() {
    return {
      currentIndex: 0,
      filters: filters
    };
  },

  computed: {
    filteredNames: function filteredNames() {
      return filters[this.visibility](this.names);
    },
    availableNames: function availableNames() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["size"])(this.filteredNames);
    },
    currentName: function currentName() {
      if (this.currentIndex < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["size"])(this.filteredNames)) {
        return this.filteredNames[this.currentIndex];
      } else {
        return 'Too Far';
      }
    },
    prevAvailable: function prevAvailable() {
      if (this.currentIndex > 0) {
        return true;
      } else {
        return false;
      }
    },
    nextAvailable: function nextAvailable() {
      if (this.currentIndex < this.availableNames - 1) {
        return true;
      } else {
        return false;
      }
    },

    rating: function rating() {
      if (this.currentName && this.currentName.rating && this.currentName.rating[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get()]) {
        return this.currentName.rating[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get()];
      } else {
        return -1;
      }
    }
  },
  methods: {
    addRating: function addRating(nameKey, rating) {
      var _this = this;

      return namesModel.addRating(nameKey, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get(), rating).then(function () {
        _this.nextName();
      });
    },
    removeRating: function removeRating(nameKey) {
      return namesModel.removeRating(nameKey, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get());
    },
    addComment: function addComment(nameKey, comment) {
      return namesModel.addComment(nameKey, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* User */])().get(), comment);
    },
    prevName: function prevName() {
      this.currentIndex = this.currentIndex - 1;
    },
    nextName: function nextName() {
      if (this.nextAvailable) {
        this.currentIndex = this.currentIndex + 1;
      } else {}
    }
  },
  firebase: {
    names: names
  }
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    legend: String,
    items: {
      type: Array,
      default: function _default() {
        return [{
          title: '5 Stars',
          value: 5
        }, {
          title: '4 Stars',
          value: 4
        }, {
          title: '3 Stars',
          value: 3
        }, {
          title: '2 Stars',
          value: 2
        }, {
          title: '1 Star',
          value: 1
        }];
      }
    },
    value: {
      type: Number,
      default: -1
    },
    kind: {
      type: String,
      default: 'grow',
      validator: function validator(val) {
        return ['basic', 'slot', 'grow', 'growRotate', 'fade', 'checkmark'].indexOf(val) > -1;
      }
    }
  },
  data: function data() {
    return {
      selected: this.value
    };
  },

  methods: {
    uuid: function uuid(index) {
      return 'rating-' + this._uid + '-item-' + index;
    },
    hasChecked: function hasChecked(index) {
      return this.count - index === this.value;
    },
    change: function change(e) {
      this.selected = e.target.value >>> 0;
      this.$emit('change', this.selected, this.value);
    }
  },
  computed: {
    count: function count() {
      return this.items.length;
    }
  }
};

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(101)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  "data-v-d3ff4dd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-159ca27e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-136e7804",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-539c3043",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-a69c750e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-2c7ffc4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h3', [_vm._v("Namen Finder")]), _vm._v(" "), _c('p', [_vm._v("\n    Wie findet man einen Namen?\n  ")]), _vm._v(" "), _c('h5', [_vm._v("\n    Wie heißt du?\n  ")]), _vm._v(" "), (_vm.userNameAvailable && !_vm.modUser) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n          " + _vm._s(_vm.greeting) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.toggleUserEdit
    }
  }, [_vm._v("Wechseln")])])])]) : _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('form', {
    staticClass: "column col-8",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.greeting
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary input-group-btn",
    on: {
      "click": _vm.setUserName
    }
  }, [_vm._v("Name festlegen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.userNameAvailable) ? _c('div', {
    staticClass: "onlyUser"
  }, [_c('h5', [_vm._v("\n      Bewerte Namen:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: [_vm.userNameAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.move({
          name: 'Names',
          params: {
            visibility: 'favorite'
          }
        })
      }
    }
  }, [_vm._v("\n              Start\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n            Favoriten\n          ")])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message"
  }, [_c('div', {
    staticClass: "chat-message-content container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "chat-time"
  }, [_vm._v(_vm._s(_vm.dateTimeValue))])]), _vm._v(" "), _c('div', {
    staticClass: "column col-9"
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_vm._v(_vm._s(_vm.message))])])])])])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "starRatingFieldset",
    class: [("starability-" + _vm.kind), 'rating']
  }, [(_vm.legend) ? _c('legend', [_vm._v(_vm._s(_vm.legend))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return [_c('input', {
      attrs: {
        "type": "radio",
        "id": _vm.uuid(index),
        "name": "rating"
      },
      domProps: {
        "value": item.value,
        "checked": _vm.hasChecked(index)
      },
      on: {
        "click": function($event) {
          _vm.change($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "touchable",
      attrs: {
        "for": _vm.uuid(index),
        "title": item.title || ''
      }
    }, [_vm._v(_vm._s(item.label || ''))])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "NameCard"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.name.value))])]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('StarRating', {
    attrs: {
      "value": _vm.rating
    },
    on: {
      "change": _vm.starChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns center"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_c('Chat', {
    attrs: {
      "nameRef": _vm.name,
      "addComment": _vm.addComment
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NameCard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, _vm._l((_vm.names), function(name) {
    return _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "columns col-oneline"
    }, [_c('div', {
      staticClass: "column col-4"
    }, [_c('p', {
      staticClass: "float-left"
    }, [_vm._v("\n          " + _vm._s(name.value)), (name.favorite) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "column col-6"
    }, [_vm._v("\n          Total: "), _c('b', [_vm._v(_vm._s(_vm.endRating(name.rating)))]), _vm._v(" "), _c('br'), _vm._v("\n          Avg: " + _vm._s(_vm.average(name.rating)) + " - Count: " + _vm._s(_vm.ratingCount(name.rating)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.deleteRecommendation(name['.key'])
        }
      }
    }, [_vm._v("Delete")])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar"
  }, [_c('section', {
    staticClass: "navbar-primary"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  })])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NameCard"
  }, [_vm._m(0), _vm._v(" "), (_vm.availableNames) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n      " + _vm._s(_vm.currentIndex + 1) + " / " + _vm._s(_vm.availableNames) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-nav"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('Card', {
    attrs: {
      "name": _vm.currentName,
      "rating": _vm.rating,
      "addRating": _vm.addRating,
      "removeRating": _vm.removeRating,
      "addComment": _vm.addComment
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn",
    class: [_vm.prevAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.prevName()
      }
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn",
    class: [_vm.nextAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.nextName()
      }
    }
  }, [_vm._v("Next")])])])])])]) : _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-people"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("You have no new names")]), _vm._v(" "), _c('p', {
    staticClass: "empty-meta"
  }, [_vm._v("Add a new name!")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("On the frontpage")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar"
  }, [_c('section', {
    staticClass: "navbar-primary"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  })])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "live-chat"
    }
  }, [_c('div', {
    staticClass: "chat"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.viewComments
    }
  }, [_vm._v("Kommentare anzeigen (" + _vm._s(_vm.nameRef.totalComment) + ")")])]), _vm._v(" "), (_vm.showComments) ? _c('div', {
    staticClass: "chat-history"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentMsg),
      expression: "commentMsg"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Kommentar schreiben...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.commentMsg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentMsg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.comment($event)
      }
    }
  }, [_vm._v("Kommentieren")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.sortedComments), function(comment) {
    return _c('ChatMessage', {
      key: comment['.key'],
      attrs: {
        "message": comment.comment,
        "userName": comment.user,
        "datum": comment.dateTime
      }
    })
  })], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spectre_css_dist_spectre_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spectre_css_dist_spectre_exp_css__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spectre_css_dist_spectre_exp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_spectre_css_dist_spectre_exp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(28);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});

/***/ })
],[128]);


// WEBPACK FOOTER //
// static/js/app.e1268eeed537ad251f08.js